import { render, staticRenderFns } from "./OnboardingCardStatus.vue?vue&type=template&id=462fb4ee&"
import script from "./OnboardingCardStatus.vue?vue&type=script&lang=js&"
export * from "./OnboardingCardStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports